'use strict';
'use es6';

// Handly functions

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.noop = noop;
exports.identity = identity;
exports.truthy = truthy;
exports.isFunction = isFunction;
exports.isObject = isObject;
exports.isDOMNode = isDOMNode;
exports.capitalizeFirst = capitalizeFirst;
exports.camelCaseToSpace = camelCaseToSpace;
exports.capitalizeAll = capitalizeAll;
exports.isHidden = isHidden;
function noop() {}

function identity(i) {
  return i;
}

function truthy() {
  return true;
}

// Checks
function isFunction(val) {
  return val && {}.toString.call(val) === '[object Function]';
}

function isObject(val) {
  return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && Array.isArray(val) === false;
}

function isDOMNode(node) {
  return isObject(node) && 'nodeType' in node && node.nodeType === 1 && node.cloneNode;
}

// String manipulation functions
function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function camelCaseToSpace(string) {
  return string.replace(/([A-Z])/g, ' $1');
}

function capitalizeAll(string) {
  return string.replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

function isHidden(element) {
  return element.element.attributes.type.value === 'hidden';
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/utils.js
// module id = 0
// module chunks = 0 1 2 3